
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M16 14.666A5.333 5.333 0 1016 4a5.333 5.333 0 000 10.666zm-4.926 4.13a8.62 8.62 0 011.497-.13h6.858A8.574 8.574 0 0128 27.238a3.429 3.429 0 01-3.429 3.428H7.43A3.429 3.429 0 014 27.238a8.574 8.574 0 017.074-8.441zm.56-2.758a8 8 0 118.73-13.41 8 8 0 01-8.73 13.41zm-4.967 11.2c0 .42.34.762.762.762H24.57c.421 0 .762-.341.762-.762a5.905 5.905 0 00-5.904-5.905H12.57a5.905 5.905 0 00-5.904 5.905z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      